/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Display_NameInputs */

const en_profile_display_name = /** @type {(inputs: Profile_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display name`)
};

const pt_br2_profile_display_name = /** @type {(inputs: Profile_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome de exibição`)
};

/**
* | output |
* | --- |
* | "Display name" |
*
* @param {Profile_Display_NameInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const profile_display_name = /** @type {((inputs?: Profile_Display_NameInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Display_NameInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_display_name(inputs)
	return pt_br2_profile_display_name(inputs)
});